import { render, staticRenderFns } from "./CepDetailsStudents.vue?vue&type=template&id=5b615ae0&scoped=true&"
import script from "./CepDetailsStudents.vue?vue&type=script&lang=js&"
export * from "./CepDetailsStudents.vue?vue&type=script&lang=js&"
import style0 from "./CepDetailsStudents.vue?vue&type=style&index=0&id=5b615ae0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b615ae0",
  null
  
)

export default component.exports